@if (modus() == 'boks') {
  <span class="boks" [class]="'status_'+oppgave().status">
    {{ statusnavn() }}
  </span>

} @else {
  <span class="utvidet" [class]="'status_'+utvidetStatus()" [matTooltip]="tooltip()">
    @switch (utvidetStatus()) {
      @case (statuser.uten_frist) {
        {{ 'Ingen frist satt'|translate }}
      }
      @case (statuser.ikke_paabegynt) {
        {{ 'Forfaller {dato}'|translate : {dato: frist()|plaindate_relativ|async} }}
      }
      @case (statuser.paabegynt) {
        @if (oppgave().frist) {
          {{ 'Påbegynt, forfaller {dato}'|translate : {dato: frist()|plaindate_relativ|async} }}
        } @else {
          {{ 'Påbegynt'|translate }}
        }
      }
      @case (statuser.overskredet) {
        {{ 'Forfalt {dato}'|translate : {dato: frist()|plaindate_relativ|async} }}
      }
      @case (statuser.utfoert) {
        {{ 'Utført {dato}'|translate : {dato: oppgave().utfoertDato|zoneddatetime_relativ:{dateStyle: 'short'}|async} }}
      }
    }
  </span>
}
